import { sortNatural } from '__core/shared/util/array';
import template from './illionAccessSeekerDialog.template.html';

export default {
  bindings: {
    onFinished: '&',
    idTicket: '<',
    latestScore: '<',
    isIllionEnabled: '<',
    contact: '<',
    loanAmount: '<'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $filter,
      $mdDialog,
      eventService,
      illionService,
      ContactCreditScore,
      ContactCreditScoreType,
      Contact,
      contactService,
      uiService,
      notesService,
      ILLION
    ) {
      'ngInject';

      const $ctrl = this;

      $ctrl.initialize = () => {
        $mdDialog
          .show({
            targetEvent: '',
            locals: {
              isIllionEnabled: $ctrl.isIllionEnabled,
              contact: $ctrl.contact,
              loanAmount: $ctrl.loanAmount,
              idTicket: $ctrl.idTicket
            },
            template,
            controllerAs: '$ctrl',
            multiple: true,
            controller(isIllionEnabled, contact, loanAmount, idTicket) {
              const ctrl = this;
              ctrl.idTicket = idTicket;
              ctrl.latestScore = $ctrl.latestScore;
              ctrl.isReady = true;
              ctrl.creditScore = null;
              ctrl.isIllionEnabled = isIllionEnabled;
              ctrl.loanAmount = loanAmount || 1;
              ctrl.CurrentCurrency = $rootScope.CurrentCurrency;
              ctrl.creditObligation = null;
              ctrl.availableCreditObligations = ILLION.CREDIT_OBLIGATION;
              ctrl.accountType = null;
              ctrl.availableAccountTypes = sortNatural(ILLION.ACCOUNT_TYPE_ACCESS_SEEKER);
              ctrl.contact = Contact.build(JSON.parse(JSON.stringify(contact)));
              ctrl.isErrorResponse = false;
              ctrl.error = '';

              ctrl.hasErrors = () =>
                !ctrl.isIllionEnabled ||
                !ctrl.contact.person.information.firstName ||
                !ctrl.contact.person.information.familyName ||
                ctrl.contact.person.information.gender.name === 'none' ||
                !ctrl.contact.person.contact.address.street ||
                !ctrl.contact.person.contact.address.suburb ||
                !ctrl.contact.person.contact.address.state ||
                !ctrl.contact.person.contact.address.postCode;

              ctrl.confirm = () => {
                if (!ctrl.sendIllion.$valid || ctrl.hasErrors()) {
                  return;
                }
                ctrl.isReady = false;
                illionService
                  .accessSeeker({
                    idTicket: ctrl.idTicket,
                    idContact: ctrl.contact.id,
                    accountType: ctrl.accountType,
                    creditObligation: ctrl.creditObligation,
                    loanAmount: ctrl.loanAmount
                  })
                  .then((result) => {
                    if (result.status) {
                      ctrl.creditScore = ContactCreditScore.build({
                        idTicket: ctrl.idTicket,
                        idAccount: $rootScope.CurrentAccount.id,
                        enquiryId: result?.results?.requestSummary?.internalReference,
                        bureauReference:
                          result?.results?.requestSummary?.uniqueCustomerReference,
                        score: result?.results?.creditReport?.scores?.score?.score,
                        keyFactors: result?.results?.notification,
                        type: ContactCreditScoreType.illion
                      });
                      ctrl.isReady = true;

                      uiService.toast({
                        text: {
                          p1: 'Credit score',
                          p2: 'retrieved',
                          p3: 'and saved'
                        },
                        success: true,
                        warn: false
                      });
                      $mdDialog.hide({
                        idContact: ctrl.contact.id,
                        creditScore: []
                          .concat(ctrl.contact?.creditScore)
                          .concat(ctrl.creditScore)
                      });
                    } else {
                      ctrl.isErrorResponse = true;
                      ctrl.error = result.errorMessage;
                    }
                  })
                  .catch(() => {
                    ctrl.isReady = true;
                  });
              };
              ctrl.cancel = () => {
                $mdDialog.hide();
              };
            }
          })
          .then((result) => {
            $ctrl.onFinished(result);
          });
      };

      $ctrl.$onInit = () => {
        $ctrl.initialize();
      };
    }
  }
};
